<svg
  [style.width.px]="diameter"
  [style.height.px]="diameter"
  [attr.viewBox]="_getViewBox()"
  xmlns="http://www.w3.org/2000/svg"
  preserveAspectRatio="none"
  #svg
>
  <circle
    cx="50%"
    cy="50%"
    [attr.r]="_getCircleRadius()"
    [style.stroke-width.%]="_getCircleStrokeWidth()"
    [style.transform-origin]="_getCircleTransformOrigin(svg)"
  ></circle>
  <circle
    cx="50%"
    cy="50%"
    [attr.r]="_getCircleRadius()"
    [style.stroke-dashoffset.px]="_getStrokeDashOffset()"
    [style.stroke-dasharray.px]="_getStrokeCircumference()"
    [style.stroke-width.%]="_getCircleStrokeWidth()"
    [style.transform-origin]="_getCircleTransformOrigin(svg)"
    [style.animation-name]="
      'circular-progress-indeterminate-' + _spinnerAnimationLabel
    "
    class="meter"
  ></circle>
</svg>
<div class="circular-progress-content">
  <ng-content></ng-content>
</div>
